module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "firstcenter"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dedication (from Paul Copan)")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("To my loving wife, Jacqueline,")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("whose gentle and wise spirit radiates")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("the glory and presence of God")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("and is a daily encouragement and inspiration")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("to me and our children.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d071e90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedication.vue
// module id = 63
// module chunks = 0